<div class="plan-alert-container display-flex plan-alert-shadow pad-8 font-14" [class]="getPlanAlertClass()"
    *ngIf="!isClosed">

    <ng-container [ngSwitch]="alertType">
        <!-- Expired Plan Alert -->
        <div *ngSwitchCase="PlanAlertType.PLAN_EXPIRED" class="flex-centered-container flex-grow">
            <ng-container *ngTemplateOutlet="alertConfig"></ng-container>
        </div>

        <!-- Auto Renewal Alert -->
        <div *ngSwitchCase="PlanAlertType.PLAN_AUTORENEWAL" class="flex-centered-container flex-grow">
            <ng-container *ngTemplateOutlet="alertConfig"></ng-container>
        </div>

        <!-- Validity Alert -->
        <div class="flex-centered-container flex-grow" *ngSwitchCase="PlanAlertType.PLAN_VALIDITY">
            <ng-container *ngTemplateOutlet="alertConfig"></ng-container>
        </div>

        <!-- Zero Plan Alert -->
        <div class="flex-centered-container flex-grow" *ngSwitchCase="PlanAlertType.PLAN_ZERO">
            <ng-container *ngTemplateOutlet="alertConfig"></ng-container>
        </div>
    </ng-container>

    <div>
        <mat-icon class="cursor-pointer margin-right" (click)="close()">
            close
        </mat-icon>
    </div>
</div>

<ng-template #alertConfig>
    <mat-icon class="margin-4-right"
        [ngClass]="alertType === PlanAlertType.PLAN_EXPIRED ? 'text-negative' : 'plan-alert-warning-text'">
        error
    </mat-icon>
    <div class="margin-right">
        {{alertConfigs[alertType].alertText}}
    </div>
    <a class="margin-right decoration-underline cursor-pointer"
        [ngClass]="alertType === PlanAlertType.PLAN_EXPIRED ? 'text-negative' : 'plan-alert-warning-text'"
        (click)="upgrade()" *ngIf="alertConfigs[alertType].alertLink">
        {{alertConfigs[alertType].alertLink}}
    </a>
</ng-template>